<template>
    <div class="accountBalance">
        <div class="infoWrap center">
            <div class="title">{{'components/sidebar/account-balance.title' | trans}}</div>
            <div class="value">
                {{ isNaN(user.account_balance) ? ''  : parseFloat(user.account_balance).toFixed(2) }}
                <span>{{ currency }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    //import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        components : {  },

        computed : {
            ...mapState(['user']),
            currency: function() {
                if (this.user.instalment) {
                    return typeof this.user.instalment.currency !== 'undefined' ? this.user.instalment.currency.toUpperCase() : '';
                }
            }
        },

        methods: {

        }
    }
</script>
